import React from 'react';
export function PrivacyPolicy() {
  return <div className="text-gray-700 space-y-6 leading-relaxed" data-id="element-153">
      <p className="text-gray-500 text-sm mb-6" data-id="element-154">
        Última actualización: Marzo 2026
      </p>

      <section data-id="element-155">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-156">
          1. Introducción
        </h3>
        <p data-id="element-157">
          En Zeklo Club, valoramos y respetamos tu privacidad. Esta Política de
          Privacidad explica cómo recopilamos, utilizamos, protegemos y
          compartimos tu información personal cuando visitas nuestro sitio web y
          adquieres nuestros productos digitales.
        </p>
      </section>

      <section data-id="element-158">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-159">
          2. Recopilación de Datos
        </h3>
        <p className="mb-3" data-id="element-160">
          Podemos recopilar los siguientes tipos de información:
        </p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-161">
          <li data-id="element-162">
            <strong data-id="element-163">Datos de contacto:</strong> Nombre y dirección de correo
            electrónico al realizar una compra.
          </li>
          <li data-id="element-164">
            <strong data-id="element-165">Datos de pago:</strong> Información procesada de forma
            segura a través de nuestros proveedores de pago (Redsys, Stripe,
            PayPal). Nosotros no almacenamos los detalles completos de tu
            tarjeta.
          </li>
          <li data-id="element-166">
            <strong data-id="element-167">Datos de navegación:</strong> Información sobre cómo
            interactúas con nuestro sitio web (dirección IP, tipo de navegador,
            páginas visitadas) mediante el uso de cookies.
          </li>
        </ul>
      </section>

      <section data-id="element-168">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-169">
          3. Uso de los Datos
        </h3>
        <p className="mb-3" data-id="element-170">
          Utilizamos tu información personal para los siguientes fines:
        </p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-171">
          <li data-id="element-172">
            Procesar tus pagos y entregar los productos digitales adquiridos.
          </li>
          <li data-id="element-173">
            Enviarte correos electrónicos transaccionales (confirmación de
            compra, acceso al producto).
          </li>
          <li data-id="element-174">Proporcionar soporte al cliente y responder a tus consultas.</li>
          <li data-id="element-175">
            Mejorar nuestro sitio web y personalizar tu experiencia de usuario.
          </li>
          <li data-id="element-176">
            Enviarte comunicaciones de marketing (solo si has dado tu
            consentimiento expreso), de las cuales puedes darte de baja en
            cualquier momento.
          </li>
        </ul>
      </section>

      <section data-id="element-177">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-178">
          4. Almacenamiento y Seguridad
        </h3>
        <p data-id="element-179">
          Implementamos medidas de seguridad técnicas y organizativas estándar
          de la industria para proteger tu información personal contra el acceso
          no autorizado, la alteración, divulgación o destrucción. Tus datos se
          almacenan en servidores seguros y solo el personal autorizado tiene
          acceso a ellos.
        </p>
      </section>

      <section data-id="element-180">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-181">
          5. Derechos del Usuario (RGPD)
        </h3>
        <p className="mb-3" data-id="element-182">
          De acuerdo con el Reglamento General de Protección de Datos (RGPD),
          tienes derecho a:
        </p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-183">
          <li data-id="element-184">Acceder a los datos personales que tenemos sobre ti.</li>
          <li data-id="element-185">Solicitar la rectificación de datos inexactos o incompletos.</li>
          <li data-id="element-186">
            Solicitar la eliminación de tus datos personales ("derecho al
            olvido").
          </li>
          <li data-id="element-187">
            Oponerte al procesamiento de tus datos o solicitar la restricción
            del mismo.
          </li>
          <li data-id="element-188">
            Solicitar la portabilidad de tus datos a otro proveedor de
            servicios.
          </li>
        </ul>
        <p className="mt-3" data-id="element-189">
          Para ejercer cualquiera de estos derechos, por favor contáctanos a
          través del correo electrónico proporcionado al final de esta política.
        </p>
      </section>

      <section data-id="element-190">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-191">
          6. Cookies
        </h3>
        <p data-id="element-192">
          Utilizamos cookies y tecnologías similares para garantizar el
          funcionamiento básico del sitio web, analizar el tráfico y mejorar tu
          experiencia. Puedes configurar tu navegador para rechazar todas las
          cookies o para que te avise cuando se envíe una cookie, aunque esto
          podría afectar la funcionalidad de ciertas partes del sitio.
        </p>
      </section>

      <section data-id="element-193">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-194">
          7. Terceros
        </h3>
        <p data-id="element-195">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye a los terceros de confianza que nos asisten
          en la operación de nuestro sitio web, la conducción de nuestro negocio
          o el servicio a nuestros usuarios (como pasarelas de pago y
          proveedores de email marketing), siempre que dichas partes acuerden
          mantener esta información confidencial.
        </p>
      </section>

      <section data-id="element-196">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-197">
          8. Contacto
        </h3>
        <p data-id="element-198">
          Si tienes alguna pregunta, inquietud o solicitud relacionada con esta
          Política de Privacidad o el manejo de tus datos personales, no dudes
          en contactarnos en:{' '}
          <a href="mailto:zeklo.club@gmail.com" className="text-gold hover:underline font-semibold" data-id="element-199">
            zeklo.club@gmail.com
          </a>
        </p>
      </section>
    </div>;
}